'use client'

import { bff_client } from '@/lib/apiClient'
import { zodResolver } from '@hookform/resolvers/zod'
import { HTTPError } from 'ky'
import { LoaderCircle } from 'lucide-react'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'
import { z } from 'zod'
import { Button } from '../ui/button'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../ui/form'
import { Input } from '../ui/input'

const confirmUseFormSchema = z.object({
  email: z
    .string()
    .min(1, { message: 'O campo email é obrigatorio' })
    .email({ message: 'E-mail inválido' }),
})

type ConfirmUseFormType = z.infer<typeof confirmUseFormSchema>

interface VerifyUserFormProps {
  setViewForm: (value: 'sign-in' | 'sign-up' | 'verify') => void
  setEmail: (email: string) => void
}

export default function VerifyUserForm({
  setViewForm,
  setEmail,
}: VerifyUserFormProps) {
  const form = useForm<ConfirmUseFormType>({
    resolver: zodResolver(confirmUseFormSchema),
    defaultValues: {
      email: '',
    },
  })

  const {
    handleSubmit,
    control,
    formState: { isSubmitting },
  } = form

  async function handleVerifyUser({ email }: ConfirmUseFormType) {
    try {
      await bff_client
        .get('user/verify', {
          searchParams: { email },
        })
        .json()

      setEmail(email)
      setViewForm('sign-in')
      // } else {
      //   console.log('OPA')
      //   setViewForm('sign-up')
    } catch (error) {
      if (error instanceof HTTPError) {
        const response = await error.response.json()

        if (response.status === 'error') {
          setViewForm('sign-up')
          setEmail(email)

          return
        }
      }

      toast.error('Ops, algo deu errado, tente novamente!', {
        position: 'top-right',
        duration: 6000,
      })
    }
  }

  const emailFieldError = form.formState.errors.email
  const emailError = !!emailFieldError?.message

  return (
    <Form {...form}>
      <form
        className="mt-6 bg-white"
        noValidate
        onSubmit={handleSubmit(handleVerifyUser)}
      >
        <FormField
          control={control}
          name="email"
          render={({ field }) => (
            <FormItem className="relative space-y-0">
              <FormLabel className="-top-2 absolute left-2.5 z-10 bg-white px-1 font-medium text-[#525252] text-xs">
                Seu E-mail
              </FormLabel>
              <FormControl>
                <Input
                  className="rounded text-sm placeholder:text-[#737373] data-[error=true]:border-red-500"
                  data-error={emailError}
                  disabled={isSubmitting}
                  placeholder="Digite seu e-mail"
                  {...field}
                />
              </FormControl>
              <FormMessage className="text-xs" />
            </FormItem>
          )}
        />

        <div className="mt-3.5">
          <Button
            className="h-10 rounded-1xl"
            disabled={isSubmitting}
            type="submit"
          >
            {isSubmitting ? (
              <LoaderCircle className="size-6 animate-spin" />
            ) : (
              'Avançar'
            )}
          </Button>
        </div>
      </form>
    </Form>
  )
}
